module.exports = __webpack_public_path__ + "static/media/App_BackArrow.48d9b3f6.svg";